<div class="row">
  @if (menusCreated()) {
    <app-menus-counter class="stat-item" [counter]="menusCreated()" />
  }
  @if (lastMenu()) {
    <app-last-menu
      class="stat-item"
      [menu]="lastMenu()"
      (previewMenu)="previewMenu.emit($event)"
    />
  }
  <!--<app-popular-menu *ngIf="popularDish" class="stat-item" [dish]="popularDish"></popular-menu>-->
</div>
